module.exports = __webpack_public_path__ + "static/media/download.a65eeec7.gif";